import { escapeHtml, externalLinkButton } from '../ui/dom.js';

export interface SoftwareItem {
  Title?: string;
  Categories: string[];
  Authors: string[];
  Description?: string;
  URL?: string;
}

export interface SoftwareData {
  Recommendations?: SoftwareItem[];
}

export function renderSoftware(items: SoftwareItem[]): string {
  return items
    .map((item) => {
      const link = item.URL ? ` ${externalLinkButton(item.URL)}` : '';
      const authorsLabel = item.Authors.length > 1 ? 'Authors' : 'Author';
      return `<wa-card appearance="outlined">
        <h4 slot="header">${escapeHtml(item.Title ?? '')}${link}</h4>
        <p><strong>Categories:</strong> ${escapeHtml(item.Categories.join(', '))}</p>
        <p><strong>${authorsLabel}:</strong> ${escapeHtml(item.Authors.join(', '))}</p>
        <p>${escapeHtml(item.Description ?? '')}</p>
      </wa-card>`;
    })
    .join('');
}
